import { GameObjects } from "phaser";

export default class ButtonPressed extends GameObjects.Image {
    constructor(scene, x, y, texture) {
        super(scene, x, y, texture);
        this.setInteractive();
        this.setScale(1.5);
        this.setAlpha(0.4);
        this.setOrigin(0, 1); this.setScrollFactor(0);
        this.isDown = false;

        this.onPressed = null;
        this.onReleased = null;
        this.on('pointerdown', () => { this.isDown = true; this.setAlpha(1)});
        this.on('pointerup', () => { this.pointerUp(); });
        this.on('pointerout', () => { this.pointerUp(); });
    }

    pointerUp() {
        this.isDown = false;
        this.setAlpha(0.4);
        if (this.onReleased != null) this.onReleased();
    }
}